<template>

  <CommonPrivateView>
    <template v-slot:header>
      
      <div class="w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]">
        Asignar invitación
      </div>

    </template>
    <template v-slot:content>
      
      <Form @submit="onSubmit" class="w-full" :validation-schema="schema" @invalid-submit="onInvalidSubmit">
        <div class="relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5">
          <div class="flex items-center justify-between font-semibold text-lg ">
            INVITACIONES
          </div>

          <div class="container mx-auto block w-full mt-4 space-y-4">
            
            <div class="w-full flex flex-col font-normal text-lg text-green-800 bg-green-100 border rounded-lg shadow-sm p-2 mt-3">
                <div>Grupo <b>{{grupoInvitacion?.descripcion}}</b></div>
                <div>Código de invitación <b>{{invitacion?.codigoInvitacion}}</b></div>
            </div>

            <div class="container mx-auto block w-full">
              
            

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2">
                  <label class="block mb-1">Mail (*)</label>
                  <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
                    <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/2">
                  <label class="block mb-1">Nombre (*)</label>
                  <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
                    <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
                  </Field>
                </div>
                <div class="w-full px-2 md:w-1/2">
                  <label class="block mb-1">Apellido (*)</label>
                  <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
                    <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/1">
                  <label class="block mb-1">DNI / Pasaporte (*)</label>
                  <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
                    <InputText v-bind="field" type="numeric" placeholder="Documento / Pasaporte" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-1/2">
                  <label class="block mb-1">Empresa (Opcional)</label>
                  <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
                    <InputText v-bind="field" type="text" placeholder="Empresa" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
                  </Field>
                </div>
                <div class="w-full px-2 md:w-1/2">
                  <label class="block mb-1">Cargo (Opcional)</label>
                  <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
                    <InputText v-bind="field" type="text" placeholder="Cargo" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
                  </Field>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                <div class="w-full px-2 md:w-4/12">
                  <label class="block mb-1">País</label>
                  <Dropdown v-model="selectedCountry" :options="paises" optionLabel="descripcion" placeholder="Seleccione un país" class="input-base" />
                </div>
                <div class="w-full px-2 md:w-2/12">
                  <label class="block mb-1">Cód. país</label>
                  <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.id" class="input-base" readonly />
                </div>
                <div class="w-full px-2 md:w-2/12">
                  <label class="block mb-1">Cód. área</label>
                  <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
                    <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
                  </Field>
                </div>
                <div class="w-full px-2 md:w-4/12">
                  <label class="block mb-1">Teléfono (Opcional)</label>
                  <Field name="telefono" v-slot="{ field, errors }" v-model="formData.telefono">
                    <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
                    <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefono" /></span>
                  </Field>
                </div>
              </div>
          
              <div class="flex flex-wrap py-2 gap-2">
                <button type="submit" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
                  <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
                  <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ACEPTAR
                </button>
                <button @click="cancelarAlta" class="mt-4 px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded"
                  :disabled="isSubmitting">
                  <i class="pi pi-times mr-2"></i>CANCELAR
                </button>
              </div>
              
            </div>

          </div>
          <!-- FIN FORM CARD -->

        </div>
      </Form>
      

    </template>
  </CommonPrivateView>  

  <BlockUI :blocked="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

import CommonPrivateView from '@/components/commons/CommonPrivateView.vue';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, StringIdLabelEntity, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE } from "qreventos-suite/constantes";
import invitacionService, { GrupoInvitacion, Invitacion } from 'qreventos-suite/invitaciones';
import seguridadServices from '@/services/seguridad.services';
import { UsuarioEmpresa } from 'qreventos-suite/src/services/suite.interfaces';

interface Pais extends StringIdLabelEntity {}

export default defineComponent({
  components: {
    InputText, Dropdown, BlockUI,
    Form, ErrorMessage, Field,
    CommonPrivateView
  },
  created() {
    document.title = "Empresas";
    suiteConfig.token = "bUJldXJDYnNJRVdFdVVCL3FnbmI4UGtXZ05VMWYzclVtbXdBYU1sclNFWT0=";
  },
  data() {
    return {
      paises: [] as Pais[],
      selectedCountry: {"id": "+54", "descripcion": "Argentina"} as Pais,
      isSubmitting: false,
      invitacion : undefined as unknown as Invitacion,
      grupoInvitacion: undefined as unknown as GrupoInvitacion,
      usuarioEmpresa: seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa,
      formData: {
        nombre: '',
        apellido: '',
        documento: '',
        empresa: '',
        cargo: '',
        codigoArea: '',
        telefono: '',
        mail:  ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese el documento').min(6, 'Al menos 6 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
      });
    }
  },  
  methods: {
    cancelarAlta() {
      this.$router.push({ path: '/invitaciones/' + this.grupoInvitacion.id });
    },
    async fillInvitacion() {
      this.isSubmitting = true;

      try {
        const id:number = Number(this.$route.params.id);
        this.invitacion = await invitacionService.findInvitacionById(this.grupoInvitacion.evento.id, id) as Invitacion;

      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Por favor revisá el formulario<br/>Se encontraron " + errores + " campos con error.", icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(this.grupoInvitacion.evento.id, "dni=" + this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        this.isSubmitting = false;
        Swal.fire({ 
            title: "Atención", 
            html: "El DNI ingresado ya fue registrado.",
            icon: "warning" }).then(() => {
              this.formData.documento = '';
            });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = this.grupoInvitacion.tipoAcreditado;

      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.dni = this.formData.documento;
      acreditado.empresa = this.formData.empresa;
      acreditado.cargo = this.formData.cargo;
      acreditado.mail = this.formData.mail;
      acreditado.invitacion = this.invitacion;
      
      acreditado.telefono = this.selectedCountry.id + this.formData.codigoArea + this.formData.telefono;
      acreditado.origenAcreditado = { "id" : 7 } as OrigenAcreditado;
      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false;

      try {

        await suiteService.saveOrUpdate(this.grupoInvitacion.evento.id, acreditado);
        
        Swal.fire({
            title: "¡Atención!",
            html: "Su transacción se realizó con éxito.",
            icon: "success",
        }).then(() => {
          
          this.$router.push({ path: '/invitaciones/' + this.grupoInvitacion.id });

        });

      } catch(error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    try {
      invitacionService.clientId = suiteConfig.clientId;
      invitacionService.token = suiteConfig.token;

      const idGrupoInvitacion:number = Number(this.$route.params.idGrupoInvitacion);
      const usuarioEmpresa:UsuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
      this.grupoInvitacion = await invitacionService.findGrupoInvitacionById(usuarioEmpresa.evento.id, idGrupoInvitacion) as GrupoInvitacion;

    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }

    this.paises = jsonCountries;
    this.fillInvitacion();    
  }
});
</script>
